// extracted by mini-css-extract-plugin
export default {"container":"SceneCard_container__z5vWi","duration":"SceneCard_duration__p19R3"};